import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  NumberInput,
  Table,
  Container,
  Columns,
  Column,
} from '@resurs/midas-react'
import { midas, colors } from '@resurs/midas'
import NumberFormat from 'react-number-format'
import moment from 'moment'

import { getText } from '../../../../internal/TextLabels'
import style from '../../shared/transactions.style'
import { FormattedAmount } from '../../shared/transaction-utils'
import {
  ActionTypes,
  TransactionTypes,
} from '../../../../util/transactionConstants'
import AuthorizedButton from '../../../../components/Authorized/AuthorizedButton'
import { Authorities } from '../../../../models/authorities'

class TransactionCartUIStore extends React.PureComponent {
  render() {
    return (
      ((this.props.cartArticles && this.props.cartArticles.length > 0) ||
        this.props.terminalTransaction) && (
        <Container>
          <Columns>
            <Column col12>
              <div style={{ overflow: 'auto', marginBottom: '1rem' }}>
                <Table disableHover>
                  <thead style={{ whiteSpace: 'nowrap' }}>
                    <tr style={style.tableHead}>
                      <th key="header-date">
                        {getText('transactions.transaction.headers.date')}
                      </th>
                      <th key="header-store">
                        {getText('transactions.transaction.headers.store')}
                      </th>
                      <th className={midas.textRight} key="header-sum">
                        {getText(
                          'transactions.transaction.headers.unitPriceIncVat',
                        )}
                      </th>

                      <th
                        style={{
                          color: colors.red2,
                          textAlign: 'center',
                          padding: '1rem 0',
                          borderLeft: '1rem solid white',
                        }}
                      >
                        <AuthorizedButton
                          key="credit"
                          fullWidth
                          type="primary"
                          kind="info"
                          text={getText(
                            'transactions.transaction.action.credit',
                          )}
                          onClick={() =>
                            this.props.setAction(
                              this.props.terminalTransaction
                                ? ActionTypes.CREDIT_TRANSACTION_AMOUNT
                                : ActionTypes.CREDIT_AMOUNT,
                            )
                          }
                          disabled={
                            (this.props.cartStatus &&
                              this.props.cartArticles &&
                              this.props.cartArticles.length > 0 &&
                              !this.props.cartStatus.creditableAmount) ||
                            (this.props.terminalTransaction &&
                              this.props.terminalTransaction.type ===
                                TransactionTypes.CREDIT)
                          }
                          authority={Authorities.TRANSACTIONS_CREDIT}
                          unauthorizedTitle={getText(
                            'transactions.transaction.action.unauthorized.credit',
                          )}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ whiteSpace: 'wrap' }}>
                    <tr>
                      {this.props.terminalTransaction && [
                        <td key="transaction-date">{`${moment(
                          this.props.terminalTransaction.date,
                        ).format('L')}`}</td>,
                        <td key="transaction-store">
                          {this.props.terminalTransaction.storeName}
                        </td>,
                        <td key="total-inc-vat" className={midas.textRight}>
                          {FormattedAmount(
                            this.props.terminalTransaction.amount,
                          )}
                        </td>,
                        <td
                          key="credited-amount"
                          style={{
                            borderLeft: '1rem solid white',
                            textAlign: 'center',
                          }}
                        >
                          {(this.props.terminalTransaction.type ===
                            TransactionTypes.DEBIT &&
                            this.props.terminalTransaction.amount > 0 &&
                            this.props.action.type ===
                              ActionTypes.CREDIT_AMOUNT) ||
                          this.props.action.type ===
                            ActionTypes.CREDIT_TRANSACTION_AMOUNT ? (
                            <div>
                              <div style={style.inputContainer}>
                                <div style={style.inputPositionAmount}>
                                  <div
                                    className={
                                      !this.props
                                        .creditTerminalTransactionIsValid
                                        ? midas.hasDanger
                                        : midas.hasSuccess
                                    }
                                  >
                                    <NumberInput
                                      id="newAmount"
                                      key="newAmount"
                                      value={
                                        this.props
                                          .creditTerminalTransactionValue || ''
                                      }
                                      onChange={amount =>
                                        this.props.handleTerminalTransactionCredit(
                                          amount,
                                        )
                                      }
                                      skipValidation
                                    />
                                  </div>
                                </div>
                              </div>
                              <span>{getText('default.currency')}</span>
                            </div>
                          ) : (
                            <NumberFormat
                              value={this.props.terminalTransaction.amount}
                              displayType="text"
                              thousandSeparator=" "
                              decimalSeparator=","
                              renderText={val =>
                                getText('default.currency', val)
                              }
                              decimalScale={2}
                              fixedDecimalScale
                            />
                          )}
                        </td>,
                      ]}
                    </tr>
                    {this.props.cartArticles &&
                      this.props.cartArticles
                        .slice(0, 1)
                        .map((article, index) => (
                          <tr key={article.rowId}>
                            <td key="transaction-date">
                              {this.props.transactionDetails &&
                                `${moment(
                                  this.props.transactionDetails.created,
                                ).format('L LT')}`}
                            </td>
                            <td key="transaction-store">
                              {this.props.transactionDetails &&
                              this.props.transactionDetails.store &&
                              this.props.transactionDetails.store.storeName
                                ? this.props.transactionDetails.store.storeName
                                : ''}
                            </td>
                            <td key="total-inc-vat" className={midas.textRight}>
                              {FormattedAmount(article.totalAmountIncVat)}
                            </td>
                            <td
                              key="credited-amount"
                              style={{
                                borderLeft: '1rem solid white',
                                textAlign: 'center',
                              }}
                            >
                              {this.props.checkAvailability() &&
                              this.props.action.type ===
                                ActionTypes.CREDIT_AMOUNT ? (
                                <div>
                                  <div style={style.inputContainer}>
                                    <div style={style.inputPositionAmount}>
                                      <div
                                        className={
                                          !article.newAmountValid
                                            ? midas.hasDanger
                                            : midas.hasSuccess
                                        }
                                      >
                                        <NumberInput
                                          id="newAmount"
                                          key="newAmount"
                                          value={`${article.newAmount}`}
                                          onChange={e => {
                                            this.props.handleNewAmountChange(
                                              e,
                                              index,
                                            )
                                          }}
                                          skipValidation
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <span>{` ${getText(
                                    'default.currency',
                                  )}`}</span>
                                </div>
                              ) : (
                                <div>
                                  {this.props.cartStatus && (
                                    <NumberFormat
                                      value={
                                        this.props.cartStatus.creditedAmount
                                      }
                                      displayType="text"
                                      decimalSeparator=","
                                      thousandSeparator=" "
                                      renderText={val =>
                                        getText('default.currency', val)
                                      }
                                      decimalScale={2}
                                      fixedDecimalScale
                                    />
                                  )}
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                  </tbody>
                  <tfoot style={{ whiteSpace: 'nowrap' }}>
                    <tr
                      style={{
                        background: '#f4f4f4',
                        borderTop: '2px solid #ccc',
                        borderBottom: '2px solid #ccc',
                      }}
                    >
                      <th
                        className={midas.textLeft}
                        style={style.tableHead}
                        colSpan="2"
                      >
                        {getText('transactions.transaction.total')}
                      </th>
                      <td className={midas.textRight}>
                        {this.props.cartStatus &&
                          FormattedAmount(
                            this.props.cartStatus.totalOrderAmount,
                          )}
                        {this.props.terminalTransaction &&
                          FormattedAmount(
                            this.props.terminalTransaction.amount,
                          )}
                      </td>
                      <td
                        style={{
                          borderLeft: '1rem solid white',
                          textAlign: 'center',
                        }}
                      >
                        {this.props.cartStatus &&
                          FormattedAmount(this.props.cartStatus.creditedAmount)}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
                <div
                  className={midas.hasDanger}
                  style={{
                    textAlign: 'right',
                    marginTop: '2rem',
                    marginBottom: '-1rem',
                  }}
                >
                  {this.props.errors.map(error => {
                    return (
                      <div key={error.name}>
                        {error.error && (
                          <p className={midas.formInputHint}>{error.message}</p>
                        )}
                      </div>
                    )
                  })}
                </div>
              </div>
              <Columns>
                <Column col12>
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      justifyContent: 'end',
                    }}
                  >
                    <Button
                      type="normal"
                      onClick={this.props.onCancel}
                      disabled={!this.props.action.type}
                    >
                      {getText('default.cancel')}
                    </Button>
                    <Button
                      type="primary"
                      onClick={this.props.handleAction}
                      disabled={
                        this.props.disablePerformButton ||
                        this.props.activeErrors ||
                        !this.props.action.type
                      }
                      loading={this.props.actionState.loading}
                      dataCy="perform-button"
                    >
                      {getText('default.perform')}
                    </Button>
                  </div>
                </Column>
              </Columns>
              <span key="addArticleWrapper" />
            </Column>
          </Columns>
        </Container>
      )
    )
  }
}

TransactionCartUIStore.propTypes = {
  cartStatus: PropTypes.object,
  errors: PropTypes.array.isRequired,
  activeErrors: PropTypes.bool.isRequired,
  handleAction: PropTypes.func.isRequired,
  handleNewAmountChange: PropTypes.func.isRequired,
  handleTerminalTransactionCredit: PropTypes.func.isRequired,
  checkAvailability: PropTypes.func.isRequired,
  cartArticles: PropTypes.any,
  action: PropTypes.object.isRequired,
  setAction: PropTypes.func.isRequired,
  actionState: PropTypes.object,
  transactionDetails: PropTypes.object,
  terminalTransaction: PropTypes.object,
  creditTerminalTransactionValue: PropTypes.string,
  creditTerminalTransactionIsValid: PropTypes.bool,
  disablePerformButton: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
}

TransactionCartUIStore.defaultProps = {
  actionState: {},
  cartArticles: null,
  cartStatus: null,
  terminalTransaction: null,
  transactionDetails: null,
  creditTerminalTransactionValue: null,
  creditTerminalTransactionIsValid: true,
}

export default TransactionCartUIStore
